import React from "react";
import "./Dashboard.css";
import { Helmet } from "react-helmet";

export default function Dashboard() {


  return (
    <>
      <Helmet>
        <title>VEHEX Dashboard</title>
      </Helmet>

      <div className="dashboard ">
        <div className="bg-white w-75 text-center p-3 m-auto rounded-3 overflow-x-auto">
        <p className="main-color fw-500">Hi, welcome back! <span className="text-black d-block">in Your business dashboard </span></p>
        <div className="goHome mt-5 mb-3">
          <button className="btn btn-danger">
            <a href="/" className="text-white fw-600">Go Back to Home</a>
          </button>
        </div>
        </div>

      </div>

    </>
  );
}
